import { render, staticRenderFns } from "./CompanyDialog.vue?vue&type=template&id=1c4d2eff"
import script from "./CompanyDialog.vue?vue&type=script&lang=js"
export * from "./CompanyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports